var render = function (_h,_vm) {var _c=_vm._c;return _c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.props.label,"value":_vm.props.value,"disabled":""}})}
var staticRenderFns = []

export { render, staticRenderFns }